import React from 'react';
// Constants
import {
  CompanyName,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import {
  MAILING_LIST_UNSUBSCRIBE_PAGE_URL,
  HOME_PAGE_URL,
} from '../../utils/constants/Routes';

// Data
import {
  mailingListUnsubscribeAdditionalMeta,
  mailingListUnsubscribeStructuredData,
} from '../../utils/data/MetaData';

// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import UnsubscribeForm from '../../components/forms/UnsubscribeForm';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { mailingListFaqItems } from '../../utils/data/faqSchemas';

function MailingUnsubscribePage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Unsubscribe', href: MAILING_LIST_UNSUBSCRIBE_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Unsubscribe – Mailing List'
        desc={`Unsubscribe from ${CompanyName}'s mailing list. Enter your email to stop receiving updates.`}
        keywords={KeywordsPages}
        additionalMeta={mailingListUnsubscribeAdditionalMeta}
        structuredData={[mailingListUnsubscribeStructuredData, breadcrumbLd]}
        canonicalPath={MAILING_LIST_UNSUBSCRIBE_PAGE_URL}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24 text-center'>
            <h1
              aria-label={`Unsubscribe from ${CompanyName}'s mailing list`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              Unsubscribe
            </h1>

            <p className='tracking-wider mt-2 text-base xs:text-lg sm:text-xl text-center opacity-90 max-w-2xl mx-auto'>
              Enter your email below to be removed from My mailing list. If you
              cannot handle My updates, you may step away.
            </p>
          </header>

          {/* Main */}
          <main
            id='main-content'
            role='main'
            tabIndex={-1}
            className='grid w-full px-6 pt-8 lg:container lg:mx-auto lg:px-24'
          >
            <section className='grid border-4 h-fit border-colour8 border-solid rounded-xl shadow-2xl bg-colour5 max-w-2xl w-full mx-auto'>
              <div className='grid gap-4 w-full h-full px-8 py-6'>
                <UnsubscribeForm />
              </div>
            </section>
          </main>
        </div>

        {/* FAQ JSON-LD (same Mailing List FAQ set) */}
        <FAQSchema items={mailingListFaqItems} />
      </div>
    </>
  );
}

export default MailingUnsubscribePage;
